export default function () {
  const widgetName = 'cardsICons';
  const widgetOpts = cardsIConsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    maxItemsVisible: 8,
    itemsPerPanel: 8,
    showDescription: false,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      $(`#${widgetName}`).remove();
      const widgetCount = data.items.length;

      $('#cardWithIcons .card-widget-item').each(function (index) {
        let iconContainer = $(this).find('.img-container');
        let iconTitle = $(this).find('.widget-title h2').text();

        if (index < widgetCount) {
          let iconPath = data.items[index].ImageWithPath;
          iconContainer.append(`<img src="${iconPath}" class="card-icon" alt="${iconTitle} Icon">`);
        }
      });
    },
  });
}
